import { appData } from '@/mocks/homepage';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-8">
              {appData.subtitle}
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              {appData.features.map((feature) => (
                <div key={feature.text} className="flex items-center gap-2.5">
                  <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center text-primary-500 flex-shrink-0">
                    <i className={feature.icon}></i>
                  </div>
                  <span className="text-xs md:text-sm text-foreground-700">
                    {feature.text}
                  </span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill"></i>
                App Store
              </a>
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill"></i>
                Android 下载
              </a>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="w-44 h-44 md:w-52 md:h-52 bg-background-50 rounded-2xl p-3 flex items-center justify-center">
              <img
                src={appData.qrPlaceholder}
                alt="扫码下载番茄漫画APP"
                className="w-full h-full object-contain rounded-lg"
              />
            </div>
            <p className="text-xs text-foreground-400 text-center mt-3">
              扫码下载番茄漫画APP
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}